/**
 * Wedding car decorations — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_decor_ideas`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const weddingCarDecorationsPack: ToilePack = {
    slug: 'wedding-car-decorations',
    category: 'occasions',
    name: 'Wedding car decorations',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 832, h: 1216},
    readings: [
        {key: 'rose', label: 'Roses', subject: 'a wedding car with red roses across the bonnet in a heart'},
        {key: 'orchid', label: 'Orchids', subject: 'a car with white orchid strings'},
        {key: 'ribbon', label: 'Ribbons', subject: 'a car with ribbons and a small bouquet'},
    ],
    styles: [
        {key: 'sedan', label: 'White sedan', style: 'a white sedan seen in a front three-quarter view at eye level, parked at a wedding venue gate hung with a marigold toran', palette: 'flower colours against glossy white paint', framing: 'the car filling the frame side to side'},
        {key: 'suv', label: 'Black SUV', style: 'a black SUV seen in a front three-quarter view on a home driveway', palette: 'flower colours against deep glossy black paint', framing: 'the car filling the frame, the house soft behind'},
        {key: 'vintage', label: 'Vintage car', style: 'a cream vintage open-top car seen from the side on a tree-lined lane', palette: 'flower colours with cream paint and chrome', framing: 'the car across the lower half, green trees above'},
    ],
    directions: ['marigold only', 'front bumper', 'simple budget'],
    directionHint: 'try: marigold only',
    seo: {
        title: 'Wedding car decoration: roses, orchids, ribbons',
        metaDescription: 'Nine wedding car decoration pictures: roses, white orchids and ribbons on a white sedan, a black SUV and a cream vintage car.',
        h1: 'Wedding car decoration: roses, orchids, ribbons',
        tagline: 'Nine pictures, three flower styles, each shown on a white sedan, a black SUV and a cream vintage car.',
        intro: 'Wedding car decoration for a family wedding in India: red roses across the bonnet in a heart, strings of white orchids, and ribbons with a small bouquet. Each style is shown on a white sedan at a venue gate hung with marigold, a black SUV on a home driveway, and a cream vintage open-top car on a tree-lined lane. Type a twist, such as marigold only or front bumper, and the same cars carry it.',
        useCases: [
            'a car for a wedding day',
            "a sample for a florist's wedding car",
            'a driveway send-off for a family',
            'a reference for choosing a flower style',
        ],
        faq: [
            {q: 'Which cars are shown?', a: 'A white sedan, a black SUV and a cream vintage open-top car.'},
            {q: 'What are the three flower styles?', a: 'Roses in a heart across the bonnet, strings of white orchids, and ribbons with a small bouquet.'},
            {q: 'Is there a number plate or any text?', a: 'No. The pictures have no number plate and no text.'},
            {q: 'Can I ask for only one flower?', a: 'Yes. Type a twist such as marigold only, and the same cars are shown with that flower.'},
        ],
    },
}
